/* eslint-disable max-len */

/**
 * Privacy Policy mock
 */
export const PrivacyPolicy = {
  fi: [
    {
      heading: '1. Rekisterin nimi',
      content: ['Avointen oppimateriaalien kirjasto (aoe.fi), jäljempänä aoe.fi-palvelu']
    },
    {
      heading: '2. Rekisterinpitäjä ja rekisterinpitäjän yhteystiedot',
      content: [
        'Opetushallitus<br />PL 380, 00531 Helsinki<br />Käyntiosoite: Hakaniemenranta 6, 00530 Helsinki<br />Sähköposti: <a href="mailto:kirjaamo@oph.fi">kirjaamo@oph.fi</a><br />Puhelin: 029 533 1000 (vaihde)'
      ]
    },
    {
      heading: '3. Rekisterinpitäjän edustaja (yhteyshenkilö)',
      content: [
        'Mai Tallgren<br />Sähköposti: <a href="mailto:aoe@oph.fi">aoe@oph.fi</a><br />Puhelin: 029 533 1000 (vaihde)'
      ]
    },
    {
      heading: '4. Tietosuojavastaavan yhteystiedot',
      content: [
        'Jyrki Tuohela<br />Sähköposti: <a href="mailto:tietosuoja@oph.fi">tietosuoja@oph.fi</a><br />Puhelin: 029 533 1000 (vaihde)'
      ]
    },
    {
      heading: '5. Henkilötietojen käsittelyn tarkoitukset, henkilötietoryhmät ja oikeusperusteet',
      content: [
        'Henkilötietojen käyttötarkoitukset:',
        '<ul><li>Oppimateriaalien tietojen julkaiseminen ja oppimateriaalien hakeminen.</li><li>Rekisteröityneiden käyttäjien tietojen sekä kirjautumis- ja käyttölokitietojen hallinta, käyttäjätilastointi ja palvelun käytössä tarvittavien evästeiden hallinta.</li></ul>',
        'Käsiteltävät henkilötietoryhmät:',
        '<ul><li>Rekisteröityneiden käyttäjien tiedot, kuten nimi, tunniste, sähköpostiosoite ja palveluiden käyttöhistoria ja -tiedot.</li><li>Oppimateriaaleissa mainitut laatijan henkilötiedot sekä oppimateriaaleihin niiden laatijoiden toimesta sisällytetyt muut henkilötiedot.</li><li>IT-hallintatiedot kuten laitteistojen tiedot liittyen tarjottuihin palveluihin, mukaan lukien tekniset tunnisteet ja tekniset tapahtumat, jotka liittyvät tarjottuihin palveluihin mukaan lukien järjestelmä- ja sovelluslokitiedot.</li>',
        'Henkilötietojen käsittelyn oikeusperusteet:',
        '<ul><li>Laki Opetushallituksesta (564/2021) 2 §</li></ul>',
        'Oppimateriaaleihin liittyvien henkilötietojen käsittelyyn ja niiden julkaisemiseen aoe.fi-palvelussa sovelletaan lainmukaisuuden arvioinnissa yleistä etua ja käyttäjien kanssa tehtävien sopimusten täytäntöönpanoa.'
      ]
    },
    {
      heading: '6. Henkilötietojen käsittelijät',
      content: [
        'Henkilötietojen käsittelijöitä ovat',
        '<ul><li>CSC-Tieteen tietotekniikan keskus Oy ja sen alihankkijat (sopimukseen perustuen: palvelun tekninen kehitys, ylläpito ja säilytys)</li><li>Kansalliskirjasto (oppimateriaalien metatietojen esittäminen).</li></ul>',
        'Lisäksi oppimateriaalien metatietoja (ml. tekijätiedot ja muut niihin tallennetut henkilötiedot) voidaan luovuttaa yksittäistapauksissa voimassa olevan lainsäädännön mukaisesti toisille oppimateriaalien tietoja esitteleville palveluille, kuten oppimisalustoille tai tietovarannoille.'
      ]
    },
    {
      heading: '7. Henkilötietojen siirtäminen kolmansiin maihin tai kansainvälisille järjestöille',
      content: [
        'Aoe.fi-palveluun tallennettuja avoimia oppimateriaaleja siirrettäessä siirretään niiden metatiedot (ml. tekijätiedot) ja aineiston tiedot esimerkiksi kansainvälisille järjestöille tai alan toimijoille niin EU/ETA-alueella kuin niiden ulkopuolella. Muita henkilötietoja ei luovuteta EU/ETA-alueen ulkopuolelle.'
      ]
    },
    {
      heading: '8. Henkilötietojen säilyttämisajat',
      content: [
        'Aoe.fi-palveluun sisältyvät materiaalit, kommentit ja muu sisältö ja näiden käsittelyyn liittyvät henkilötiedot säilytetään ja poistetaan palvelun käyttöehtojen mukaisesti, ellei arkistointia koskevasta lainsäädännöstä tai muista säädöksistä muuta johdu.',
        'Käyttäjä voi poistaa omat tietonsa, ml. kommentit ja arviot, lähettämällä pyynnön Opetushallitukselle osoitteeseen <a href="mailto:aoe@oph.fi">aoe@oph.fi</a>. Käyttäjään liittyviä poistettuja tietoja ei voi palauttaa sen jälkeen, kun käyttäjätunnus on poistettu. Poistaminen ei koske käyttäjän tallentamia oppimateriaaleja eikä niiden metatietoja. Opetushallitus pidättää kuitenkin oikeuden säilyttää niitä sisältöjä ja henkilötietoja, joita tarvitaan kolmansien osapuolien oikeuksien turvaamiseksi esimerkiksi tekijänoikeusloukkauksien osoittamiseksi.',
        'Aoe.fi-palvelun lokitiedot säilytetään 18 kk.'
      ]
    },
    {
      heading: '9. Rekisteröityneen oikeudet',
      content: [
        'Rekisteröityneellä on oikeus saada rekisterinpitäjältä tieto siitä, käsitelläänkö hänen henkilötietojaan.',
        'Rekisteröityneellä on myös oikeus pyytää',
        '<ul><li>itseään koskevat henkilötiedot</li><li>rekisterinpitäjää oikaisemaan tai poistamaan virheelliset tai vanhentuneet tiedot</li><li>henkilötietojen käsittelyn rajoittamista.</li></ul>',
        'Mikäli rekisteröitynyt katsoo, ettei hänen henkilötietojensa käsittely ole lainmukaista, rekisteröidyllä on oikeus tehdä asiasta valitus tietosuojavaltuutetulle.'
      ]
    },
    {
      heading: '10. Henkilötietojen lähde/lähteet',
      content: [
        'Palvelun keräämät tiedot, tietopankit sekä aineiston tallentajien tallentamat metatiedot (ml. tekijäryhmätiedot).'
      ]
    },
    {
      heading: '11. Henkilötietojen käsittelyn suojaaminen',
      content: [
        'Opetushallitus rekisterinpitäjänä on toteuttanut tarvittavat tekniset ja organisatoriset toimet sekä vaatii sitä myös henkilötietojen käsittelijöiltä.'
      ]
    },
    {
      heading: '12. Evästeet',
      content: [
        'Aoe.fi-palvelu käyttää vain välttämättömiä evästeitä palvelun käytön mahdollistamiseksi. Evästeet ovat istuntokohtaisia tai ne vanhenevat viimeistään 24 tuntia käytön jälkeen.'
      ]
    }
  ],
  en: [
    {
      heading: '1. Name of the register',
      content: [
        'Library of Open Educational Resources (aoe.fi), hereinafter referred to as the aoe.fi service'
      ]
    },
    {
      heading: '2. Data controller and contact details',
      content: [
        'Opetushallitus (The Finnish National Agency for Education)<br />PO Box 380, 00531 Helsinki<br />Street address: Hakaniemenranta 6, 00530 Helsinki<br />Email: <a href="mailto:kirjaamo@oph.fi">kirjaamo@oph.fi</a><br />Phone: 029 533 1000 (switch)'
      ]
    },
    {
      heading: `3. Controller's representative (contact person)`,
      content: [
        'Mai Tallgren<br />Email: <a href="mailto:aoe@oph.fi">aoe@oph.fi</a><br />Phone: 029 533 1000 (switch)'
      ]
    },
    {
      heading: '4. DPO contact information',
      content: [
        'Jyrki Tuohela<br />Email: <a href="mailto:tietosuoja@oph.fi">tietosuoja@oph.fi</a><br />Phone: 029 533 1000 (switch)'
      ]
    },
    {
      heading: '5. Purposes of, categories of and legal bases for the processing of personal data',
      content: [
        'The purposes of personal data are:',
        '<ul><li>Publishing and finding information about educational resources.</li><li>Management of information on registered users, logins and login details, user statistics, and management of cookies required in use of the service.</li></ul>',
        'Categories of personal data processed:',
        '<ul><li>Information on registered users, such as name, identifier, e-mail address and usage history and details of purchases and/or services.</li><li>Personal data of authors mentioned in educational resources, and other personal data included in educational by authors.</li><li>IT management details, such as equipment details related to services provided, including technical identifiers and technical events related to services provided, including system and application log data.</li>',
        'Legal bases for the processing of personal data:',
        '<ul><li>Finnish National Agency for Education Act (564/2021) 2 §</li></ul>',
        'In evaluating the lawfulness of processing of personal data related to educational resources and their publication on the aoe.fi service, the public interest and enforcement of agreements signed with users shall be applied.'
      ]
    },
    {
      heading: '6. Processors of personal data',
      content: [
        'The processors of personal data are:',
        '<ul><li>CSC–IT Center for Science Ltd. and its contractors (based on a contract: development, maintenance and storage of the service).</li><li>National Library (publishing metadata of educational resources)</li></ul>',
        'In addition metadata of educational resources (including information on author and other personal data) can be disclosed in accordance with valid legislation to other services publishing information about educational resources such as learning management systems and data banks.'
      ]
    },
    {
      heading: '7. Transfer of personal data to third countries or to international organizations',
      content: [
        'Upon any transfer of open educational resources, their metadata (incl. author details) and information about the material are transferred to, e.g., international organizations or operators in the sector both within and outside the European Union (EU) or the European Economic Area (EEA). Other personal data is not disclosed outside the EU or the EEA.'
      ]
    },
    {
      heading: '8. Storage periods for personal data',
      content: [
        'Materials, comments and other content included in the Open Educational Resources Service, and personal data related to the processing of these, are stored and deleted in accordance with the service’s terms of use, unless otherwise provided in legislation concerning filing or other regulations.',
        'Users can delete their personal data, including comments and reviews, by submitting a deletion request to the Finnish National Agency for Education at <a href="mailto:aoe@oph.fi">aoe@oph.fi</a>. After a user account is deleted, the deleted user data cannot be restored. The deletion does not apply to the educational resources uploaded by the user or their metadata. However, the Finnish National Agency for Education reserves the right to retain content and personal data that are required for protecting the rights of third parties, such as for proving copyright infringement.',
        'Aoe.fi services log data is stored for 18 months.'
      ]
    },
    {
      heading: '9. Data subject’s rights',
      content: [
        'Data subjects have the right to be informed, by the controller, of whether their personal data is processed.',
        'Data subjects also have the right to request:',
        '<ul><li>personal data concerning them</li><li>rectification or deletion of inaccurate or outdated data from the controller</li><li>restriction of the processing of personal data.</li></ul>',
        'If a data subject finds that the processing of their personal data is not lawful, the data subject has the right to lodge a complaint with the Data Protection Ombudsman.'
      ]
    },
    {
      heading: '10. Source(s) of personal data',
      content: [
        'Information collected by the service, data banks, and metadata submitted by persons who store material (including authorinformation).'
      ]
    },
    {
      heading: '11. Protection of the processing of personal data',
      content: [
        'The Finnish National Agency for Education, as the controller, has implemented the necessary technical and organizational measures, and also requires this from processors of personal data.'
      ]
    },
    {
      heading: '12. Cookies',
      content: [
        'Aoe.fi service uses only necessary cookies to make it possible for you to use the service. We use session cookies and cookies that expire 24 hours after using aoe.fi.'
      ]
    }
  ],
  sv: [
    {
      heading: '1. Registrets namn',
      content: ['Biblioteket för öppna lärresurser (aoe.fi), nedan aoe.fi-tjänsten.']
    },
    {
      heading: '2. Personuppgiftsansvarig och kontaktuppgifter',
      content: [
        'Utbildningsstyrelsen<br />PB 380, 00531 Helsingfors<br />Besöksadress: Hagnäskajen 6, 00530 Helsingfors<br />E-postadress: <a href="mailto:kirjaamo@oph.fi">kirjaamo@oph.fi</a><br />Telefonnummer: 029 533 1000 (växel)'
      ]
    },
    {
      heading: '3. Representant för den personuppgiftsansvarige (kontaktperson)',
      content: [
        'Mai Tallgren<br />E-postadress: <a href="mailto:aoe@oph.fi">aoe@oph.fi</a><br />Telefonnummer: 029 533 1000 (växel)'
      ]
    },
    {
      heading: '4. Kontaktuppgifter till dataskyddsombudet',
      content: [
        'Jyrki Tuohela<br />E-postadress: <a href="mailto:tietosuoja@oph.fi">tietosuoja@oph.fi</a><br />Telefonnummer: 029 533 1000 (växel)'
      ]
    },
    {
      heading:
        '5. Ändamålet med personuppgifter, personuppgiftsgrupper och de rättsliga grunderna för behandlingen av personuppgifter',
      content: [
        'Personuppgifterna används för att:',
        '<ul><li>Publicera och hitta information om undervisningsmaterialet</li><li>Behandla uppgifter om registrerade användare, administration av logginformation och användning, användarstatistik och administration av cookies som behövs för användning av tjänsten.</li></ul>',
        'Personuppgiftsgrupper som behandlas:',
        '<ul><li>Uppgifter om registrerade användare såsom namn, identifierare, e-postadress, användarhistorik och användaruppgifter avseende tjänsterna.</li><li>Personuppgifter om skaparen av ett undervisningsmaterial, som nämns i materialet, och andra personuppgifter som ingår i något undervisningsmaterial.</li><li>Uppgifter för IT-administrationen, såsom uppgifter om apparaterna som hänför sig till de tjänster som erbjuds. I dessa ingår teknisk identifiering och tekniska incidenter relaterade till tjänsterna som erbjuds, inklusive logginformation om systemet och applikationerna.</li>',
        'Rättsliga grunder för behandlingen av personuppgifter:',
        '<ul><li>Lag om Utbildningsstyrelsen (564/2021) 2 §</li></ul>',
        'Gällande bedömningen av lagenligheten tillämpas det allmänna intresset och verkställandet av avtalen som ingås med användarna på behandlingen av personuppgifter förknippade med undervisningsmaterial och på publiceringen av personuppgifter på aoe.fi-tjänsten.'
      ]
    },
    {
      heading: '6. De som behandlar personuppgifter',
      content: [
        'De som behandlar personuppgifter är',
        '<ul><li>CSC-Tieteen tietotekniikan keskus Oy och deras underleverantörer (enligt avtal: utveckling, administration och uppbevaring av tjänsten)</li><li>National Biblioteket (publicering av metadata om undervisningsmaterialet).</li></ul>',
        'Metadata om undervisningsmaterialet (inklusive uppgifter om den som skapat materialet och andra personuppgifter) kan dessutom överlåtas i enlighet med gällande lagstiftning till tjänsten som publicerar uppgifter om undervisningsmaterialet liksom lärplatformar eller databanker.'
      ]
    },
    {
      heading:
        '7. Överföring av personuppgifter till tredje länder eller internationella organisationer',
      content: [
        'Vid överföring av öppet undervisningsmaterial överförs deras metadata (inklusive uppgifter om den som skapat materialet) och uppgifter om materialet till exempel till internationella organisationer eller aktörer inom branschen såväl inom som utanför EU/ETA-området. Andra personuppgifter överlåts inte utanför EU/ETA-området.'
      ]
    },
    {
      heading: '8. Personuppgifternas uppbevaringstid',
      content: [
        'Material, kommentarer och annat innehåll i tjänsten för öppna lärresurser, samt personuppgifter med anknytning till behandlingen av dessa, uppbevaras och raderas i enlighet med användarvillkoren, såvida inte bestämmelserna i lagstiftningen eller i förordningarna om arkivering avviker från dem.',
        'Användaren kan radera sina egna uppgifter, inklusive kommentarer och bedömningar, genom att skicka en begäran om detta till Utbildningsstyrelsen på adressen <a href="mailto:aoe@oph.fi">aoe@oph.fi</a>. Raderade uppgifter om en användare kan inte återställas efter att användarnamnet har tagits bort. Raderingen gäller inte lärresurser som användaren har lagrat eller metauppgifter om dem. Utbildningsstyrelsen förbehåller sig dock rätten att lagra de innehåll och personuppgifter som behövs för att trygga tredje parters rättigheter och exempelvis bevisa kränkningar av upphovsrätten.',
        'Aoe.fi-tjänstens loggdata sparas i 18 månader.'
      ]
    },
    {
      heading: '9. Den registrerades rättigheter',
      content: [
        'Den registrerade har rätt att av den personuppgiftsansvarige ta reda på om hans eller hennes personuppgifter behandlas.',
        'Den registrerade har också rätt att begära:',
        '<ul><li>personuppgifter om sig själv</li><li>att den personuppgiftsansvarige rättar eller raderar felaktiga eller föråldrade uppgifter</li><li>att behandlingen av personuppgifterna begränsas.</li></ul>',
        'Om den registrerade anser att behandlingen av personuppgifter inte är lagenlig, har den registrerade rätt att anföra klagomål hos dataskyddsombudet.'
      ]
    },
    {
      heading: '10. Personuppgifternas källa/källor',
      content: [
        'Uppgifter som tjänsten samlar in, databanker och metadata publicerad av de som lagrar material (inklusive uppgifter om den som skapat materialet).'
      ]
    },
    {
      heading: '11. Skydd av behandlingen av personuppgifter',
      content: [
        'I egenskap av personuppgiftsansvarig har Utbildningsstyrelsen vidtagit nödvändiga tekniska och organisatoriska åtgärder och kräver detta också av dem som behandlar personuppgifter'
      ]
    },
    {
      heading: '12. Cookies',
      content: [
        'Aoe.fi-tjänsten använder nödvändiga cookies för att tjänsten fungerar smidigt. Cookies är session cookies eller dom föråldras efter 24 timmar.'
      ]
    }
  ]
}
